import React from "react";

export const GaugeLabel = ({ label }) => (
    // grouping the rectangle and label text;
    // centering inside the gauge based on the label's length
    <g transform={`translate(-${(label.length * 0.5) / 10 / 2}, -.3)`}>
        <rect
            width={(label.length * 0.5) / 10}
            height=".15"
            rx=".04"
            ry=".03"
            fill="#dbdbe7"
        />
        <text
            x={(label.length * 0.5) / 10 / 6}
            y=".1"
            fontSize=".07"
            fill="#515151"
        >
            {label}
        </text>
    </g>
);
